import axios from "axios";

// const base_path = getBaseUrl();
const base_path = window.APP_CONFIG?.BASE_URL;
// const base_path = process.env.REACT_APP_API_URL;

//----------purchase api calls-------------

export const deletePurchase = async (purchaseData) => {
  const response = await axios.post(
    `${base_path}/Api/Purchase/Delete`,
    purchaseData
  );
  return response;
};
// Create a new purchase
export const addEditPurchase = async (purchaseData) => {
  const response = await axios.post(
    `${base_path}/Api/Purchase/SaveOrUpdate`,
    JSON.stringify(purchaseData)
  );
  return response;
};

//Get purchase invoice by transaction type and branch
// from / to: optional yyyy-MM-dd (inclusive, on the entry date); without them every document (RP-D-1)
export const getPurchaseByTransType = async (branch, transType, from, to) => {
  const range =
    (from ? `&fromDate=${from}` : "") + (to ? `&toDate=${to}` : "");
  const response = axios.get(
    `${base_path}/Api/Purchase/GetAllByTransType?globalBranchID=${branch?.guid}&TransType=${transType}${range}`
  );
  return response;
};
